import React from 'react';

export default function OAuthAppNew() {
  return <div><p>Superadmin OAuth App New - coming soon</p></div>;
}
